import React from 'react'

const ScheduleWidget = () => {
  return (
    <div>
    <healcode-widget data-type="schedules" 
    data-widget-partner="object" 
    data-widget-id="0f179021470c" 
    data-widget-version="1" >
    </healcode-widget>
    </div>
  );
}

export default ScheduleWidget